<button
  (click)="download()"
  [angularticsCategory]="analyticsCategory"
  [angularticsProperties]="angularticsProperties"
  [angularticsValue]="productId"
  [disabled]="isDisabled"
  angulartics2On="click"
  angularticsAction="delivery-download"
  [angularticsLabel]="productType"
  class="btn btn-icon-only download"
  type="button"
>
  <i aria-hidden="true" class="png-icon-sm png-download"></i>
</button>
